import React from 'react';
import PageHeader from '../components/ui/PageHeader';
import { useI18n } from '../i18n/I18nContext';
import './StaticPage.css';

const About: React.FC = () => {
  const { content } = useI18n();

  return (
    <div className="static-page">
      <PageHeader page="about" />
      <div className="container static-page__body">
        {content.about.sections.map(section => (
          <section key={section.title} className="static-page__section">
            <h2>{section.title}</h2><p>{section.text}</p>
          </section>
        ))}
        <div className="static-page__values">
          {content.about.values.map(value => (
            <article key={value.title} className="static-page__value-card">
              <h3>{value.title}</h3><p>{value.description}</p>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default About;
